import { cn } from "~/lib/utils";

type Props = {
  variant?: "fixed" | "section";
  className?: string;
};

export function BackgroundGlow({ variant = "fixed", className }: Props) {
  return (
    <div
      aria-hidden="true"
      className={cn(
        "pointer-events-none overflow-hidden",
        variant === "fixed" ? "fixed inset-0" : "absolute inset-0",
        className,
      )}
    >
      <div className="absolute left-1/2 top-[-120px] h-[520px] w-[820px] -translate-x-1/2 rounded-full bg-primary/10 blur-[120px]" />
      <div className="absolute left-1/4 top-1/3 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-primary/8 blur-[140px]" />
      <div className="absolute right-1/4 top-1/2 h-[460px] w-[460px] translate-x-1/2 rounded-full bg-fuchsia-500/5 blur-[160px]" />
    </div>
  );
}
